export default __webpack_public_path__ + "static/media/4.86f923a8.webp";